/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const SupportAgent = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 20 20" fill="none">
      <g clipPath="url(#clip0_2068_14764)">
        <path
          d="M17.5012 10.1833C17.5012 5.60833 13.9512 2.5 10.0012 2.5C6.09285 2.5 2.50118 5.54167 2.50118 10.2333C2.00118 10.5167 1.66785 11.05 1.66785 11.6667V13.3333C1.66785 14.25 2.41785 15 3.33451 15H4.16785V9.91667C4.16785 6.69167 6.77618 4.08333 10.0012 4.08333C13.2262 4.08333 15.8345 6.69167 15.8345 9.91667V15.8333H9.16785V17.5H15.8345C16.7512 17.5 17.5012 16.75 17.5012 15.8333V14.8167C17.9928 14.5583 18.3345 14.05 18.3345 13.45V11.5333C18.3345 10.95 17.9928 10.4417 17.5012 10.1833Z"
          fill="currentColor"
        />
        <path
          d="M7.50118 11.6667C7.96142 11.6667 8.33451 11.2936 8.33451 10.8333C8.33451 10.3731 7.96142 10 7.50118 10C7.04094 10 6.66785 10.3731 6.66785 10.8333C6.66785 11.2936 7.04094 11.6667 7.50118 11.6667Z"
          fill="currentColor"
        />
        <path
          d="M12.5012 11.6667C12.9614 11.6667 13.3345 11.2936 13.3345 10.8333C13.3345 10.3731 12.9614 10 12.5012 10C12.0409 10 11.6678 10.3731 11.6678 10.8333C11.6678 11.2936 12.0409 11.6667 12.5012 11.6667Z"
          fill="currentColor"
        />
        <path
          d="M15.0012 9.19167C14.6012 6.81667 12.5346 5 10.0429 5C7.5179 5 4.80124 7.09167 5.0179 10.375C7.07624 9.53333 8.62624 7.7 9.0679 5.46667C10.1596 7.65833 12.4012 9.16667 15.0012 9.19167Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2068_14764">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </BaseSvgIcon>
  )
}

export default SupportAgent
